<template>
  <v-card :width="240" size="xs" :class="className">
    <v-card-title :style="{ backgroundColor: bgColor }">
      <h4 class="white--text">{{ title }}</h4>
      <p>{{textInfo}}</p>
    </v-card-title>
    <v-card-actions>

      <!-- En el slot puede entrar algo como esto -->
      <slot>


      <!-- 
        <btn-comp
        v-if="componenteEvento.visualizar_submodulo"
        @click="getAllGradosNivelAdmin(nivel)"
        </btn-comp>
      > -->
      <!-- <v-spacer></v-spacer> -->
      
      <!-- 
        <v-tooltip bottom color="#1b1b1b">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="componenteEvento.borrar_submodulo"
            v-on="on"
            class="btn_eliminar mx-2"
            fab
            x-small
            @click="deleteNivel(nivel)"
          >
            <v-icon>fa-trash-alt</v-icon>
          </v-btn>
        </template>
        <span>ELIMINAR NIVEL</span>
        </v-tooltip>
      -->

      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    

    name: "TarjetaSencilla",
    props: {
      title:{
        type:String,
        default:""
      },
      textInfo:{
        type:String,
        default:""
      },
      bgColor:{
        type:String,
        default:"#224"
      },
      width:{
        type:Number,
        default:240
      },
      className:{
        type:String,
        default:""
      }
    },
    
}
</script>
